import styled from '@emotion/styled'

const Checkbox = styled.input`
  margin-top: 0.1rem;
  margin-left: -1.5rem;
`

interface IProps {
  rxRecognitionOrderInput: boolean
  setRxRecognitionOrderInput: (value: boolean) => void
  containerClasses?: string
}

const AIRxRecognitionCheckBox = ({rxRecognitionOrderInput, setRxRecognitionOrderInput, containerClasses}: IProps) => {
  return (
    <>
      <div className={`${containerClasses ? containerClasses : 'd-flex align-items-center'}`}>
        <Checkbox
          type="checkbox"
          value={String(rxRecognitionOrderInput)}
          name={'rxRecognitionOrderInput'}
          className="form-check-input"
          checked={rxRecognitionOrderInput}
          onChange={(event) => {
            setRxRecognitionOrderInput(event.target.checked)
          }}
          id="rxRecognitionOrderInput"
        />
        <label
          className="font-weight-bolder"
          style={{
            color: '#0381d7',
          }}
          htmlFor="rxRecognitionOrderInput">
          AI Rx Recognition
        </label>
      </div>
      <span>
        (You will be asked to upload the RX form immediately after creating the order. It will then
        be processed by the AI, and the information about the patient, physician, and insurance will
        be automatically filled in.)
      </span>
    </>
  )
}

export default AIRxRecognitionCheckBox
